<template>
  <!-- READ ONLY MODE -->

  <div id="ds-label" class="option-section pad-top20" v-if="mode == 'VIEW'">
    <div class="question-container pt-10">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div v-if="!question.verticalScale" :class="this.isNumericRatingScale ? 'd-inline-block' : ''">
      <div v-if="activityDetails && activityDetails.newLayout == true">
        <div class="row">
          <div class="pl-0 pr-5 col-md-2">{{ question.minValueLabel }}</div>
          <ds-slider
            ref="slider"
            v-if="question.partitions !== 0"
            :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue"
            :piecewise="true"
            direction="horizontal"
            class="horizontal-vue-slider pt-30 col-md-8"
            :class="{
              'h-40 pl-0': isNumericRatingScale,
              'pl-20': !isNumericRatingScale
            }"
            :min="question.minValue"
            :max="question.maxValue"
            :disabled="true"
            :piecewiseLabel="true"
            :piecewiseStyle="piecewiseStyle"
            :interval="question.partitions"
            :piecewiseActiveStyle="null"
            :labelActiveStyle="null"
            :isNumericRatingScale="isNumericRatingScale"
            :dotSize="0"
            :defaultSelected="false"
          ></ds-slider>
          <ds-slider ref="slider" v-else :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue" direction="horizontal" class="horizontal-vue-slider pt-30 col-md-8" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
          <div class="pr-0 col-md-2">{{ question.maxValueLabel }}</div>
        </div>
      </div>
      <div v-else :class="{ 'd-flex flex-column': isNumericRatingScale }">
        <ds-slider
          ref="slider"
          v-if="question.partitions !== 0"
          :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue"
          :piecewise="true"
          direction="horizontal"
          class="horizontal-vue-slider"
          :class="{ 'h-40 pl-0 act-step-box-slider': isNumericRatingScale, 'pl-20': !isNumericRatingScale }"
          :min="question.minValue"
          :max="question.maxValue"
          :disabled="true"
          :piecewiseLabel="true"
          :piecewiseStyle="piecewiseStyle"
          :interval="question.partitions"
          :piecewiseActiveStyle="null"
          :labelActiveStyle="null"
          :isNumericRatingScale="isNumericRatingScale"
          :dotSize="0"
          :defaultSelected="false"
        ></ds-slider>
        <ds-slider ref="slider" v-else :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue" direction="horizontal" class="horizontal-vue-slider" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
        <div class="pt-10 scaleLabels d-flex justify-content-between textBreak p-10">
          <div class="labels ds-label-normal">{{ question.minValueLabel }}</div>
          <div class="labels right-label ds-label-normal">{{ question.maxValueLabel }}</div>
        </div>
      </div>
    </div>
    <div class="col-md-3" v-if="question.verticalScale">
      <div class="scaleLabels first">{{ question.maxValueLabel }}</div>
      <ds-slider
        ref="slider"
        v-if="question.partitions !== 0"
        :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue"
        :piecewise="true"
        direction="vertical"
        class="vertical-vue-slider p-0 mt-10"
        :class="{ 'h-auto': isNumericRatingScale }"
        width="2"
        :min="question.minValue"
        :max="question.maxValue"
        :disabled="true"
        :piecewiseLabel="true"
        :piecewiseStyle="piecewiseStyle"
        :interval="question.partitions"
        :piecewiseActiveStyle="null"
        :labelActiveStyle="null"
        :isNumericRatingScale="isNumericRatingScale"
        :dotSize="0"
        :defaultSelected="false"
      ></ds-slider>
      <ds-slider ref="slider" v-else :value="question.defaultPointerPosition == 'max' ? question.maxValue : question.minValue" direction="vertical" class="vertical-vue-slider pl-20" width="2" :min="question.minValue" :max="question.maxValue" :disabled="true" :labelActiveStyle="null" :dotSize="0"></ds-slider>
      <div class="scaleLabels last" v-if="question.verticalScale">
        {{ question.minValueLabel }}
      </div>
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="row">
      <div class="col-lg-11 p-0">
        <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
          <span
            class="add-help-text number-add-help-poition-with-score"
            :class="{
              'right-position': activityDetails.customParticipantMessaging
            }"
            :style="{
              color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Help
          </span>
        </div>
        <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
          <span
            class="add-help-text"
            :style="{
              color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Message
          </span>
        </div>
        <quill-editor class="bg-white mt-30 quill-score" v-model="question.formattedBody" :options="commonProps.editorOptionForQuestion"></quill-editor>
      </div>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40 mb-10" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>

    <div class="row form-group pt-10">
      <div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 pl-0">Intervals</div>
      <div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 p-0">
        <select name="intervals" v-model="question.intervals" v-on:change="changeLabelsLength(question.intervals)" class="form-control input-style" required>
          <option v-for="option in intervals" :key="option.name" v-bind:value="option.value">{{ option.name }}</option>
        </select>
      </div>
      <div class="col-lg-1 col-md-2 col-sm-2 col-xs-2 p-0">
        <span class="fa fa-info-circle info-circle pl-10 pt-10" aria-hidden="true" @click="toggleIntervalInfo()" @blur="hideIntervalInfo()" tabindex="-1"></span>
        <div
          class="info-circle-div"
          style="
                  width: 331px;
                  height: 60px;
                  margin-left: 27px;
                  margin-top: -29px;
                "
          v-show="intervalInfoDiv"
        >
          The difference between the maximum value and minimum value must be divisible by the intervals value.
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0 pb-50">
        <span class="scale-info">Scale Values</span>
        <span class="fa fa-info-circle info-circle pl-10" aria-hidden="true" @click="toggleScaleInfo()" @blur="hideScaleInfo()" tabindex="-1"></span>
        <div
          class="info-circle-div"
          style="
                  z-index: 90;
                  width: 453px;
                  height: auto;
                  margin-left: 108px;
                "
          v-show="scaleInfoDiv"
        >
          <b>Horizontal scales</b>: minimum = displayed on left; maximum = displayed on right
          <br />
          <b>Vertical scales</b>: minimum = displayed on bottom; maximum = displayed on top
        </div>
        <div class="row form-group pt-3">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 pl-0">Minimum</div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 p-0">
            <input type="number" class="form-control input-style" placeholder="Enter minimum value" min="-10000" max="10000" v-model="question.minValue" />
          </div>
        </div>

        <div class="row form-group pt-3">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 pl-0">Maximum</div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 p-0">
            <input type="number" class="form-control input-style" placeholder="Enter maximum value" max="10000" v-model="question.maxValue" />
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
        <span class="scale-info">Scale Labels</span>
        <div class="row form-group pt-3">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 pl-0">
            <span>Label</span>
          </div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 p-0">
            <input type="text" class="form-control input-style" placeholder="Enter minimum label" v-model="question.minValueLabel" />
          </div>
        </div>

        <div class="row form-group pt-3">
          <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 pl-0">
            <span>Label</span>
          </div>
          <div class="col-lg-10 col-md-10 col-sm-10 col-xs-10 p-0">
            <input type="text" class="form-control input-style" placeholder="Enter maximum label" v-model="question.maxValueLabel" />
          </div>
        </div>
      </div>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import dsSlider from "@/lib/ds-slider-component";
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepNumberScale",
  mixins: [activityStepCustomMessage],
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: 1
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    dsSlider,
    quillEditor
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    },
    isNumericRatingScale(v) {
      if (v) {
        this.question.defaultPointerPosition = null;
      }
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  },
  created() {
    this.$root.$on("Toggle_Preview", () => {
      if (!this.$refs) {
        return;
      }
      if (!this.$refs.slider) {
        return;
      }
      setTimeout(() => {
        [this.$refs.slider].forEach(element => {
          element.refresh();
        });
      }, 300);
    });
  },
  computed: {
    isNumericRatingScale() {
      return this.question.numericRatingScale;
    }
  },
  data() {
    return {
      piecewiseActiveStyle: {
        backgroundColor: "#3498db"
      },
      labelActiveStyle: {
        color: "#3498db"
      },
      piecewiseStyle: {
        backgroundColor: "#ccc",
        visibility: "visible",
        width: "12px",
        height: "12px"
      },
      intervals: [
        { name: " ", value: "0" },
        { name: "1", value: "1" },
        { name: "2", value: "2" },
        { name: "3", value: "3" },
        { name: "4", value: "4" },
        { name: "5", value: "5" },
        { name: "6", value: "6" },
        { name: "7", value: "7" },
        { name: "8", value: "8" },
        { name: "9", value: "9" },
        { name: "10", value: "10" },
        { name: "11", value: "11" },
        { name: "12", value: "12" },
        { name: "13", value: "13" }
      ],
      infoDiv: false,
      scaleInfoDiv: false,
      intervalInfoDiv: false,
      scoreInfoDiv: false,
      lengthInfoDiv: false,
      pointerInfoDiv: false,
      scaleValueInfoDiv: false,
      isAddHelpEnabled: false
    };
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    changeLabelsLength(intervals) {
      if (intervals == 0 || !intervals) {
        this.$toastr.error("Please specify # of intervals.");
        return;
      } else if (intervals < 1 || intervals > 14) {
        this.$toastr.error("Minimum and maximum value of interval should be 1 to 13");
        return;
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();
      if (!this.question.formattedLabels) {
        this.question.formattedLabels = [];
      }
      this.question.formattedLabels.length = intervals;
      this.$forceUpdate();
    },
    hideIntervalInfo() {
      this.intervalInfoDiv = false;
      this.$el.blur();
    },
    hideScaleInfo() {
      this.scaleInfoDiv = false;
      this.$el.blur();
    },
    showScaleInfo() {
      this.scaleInfoDiv = true;
      this.$el.focus();
    },
    showIntervalInfo() {
      this.intervalInfoDiv = true;
      this.$el.focus();
    },
    toggleIntervalInfo() {
      if (this.intervalInfoDiv) {
        this.hideIntervalInfo();
      } else {
        this.showIntervalInfo();
      }
    },
    toggleScaleInfo() {
      if (this.scaleInfoDiv) {
        this.hideScaleInfo();
      } else {
        this.showScaleInfo();
      }
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }

      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }

      if (question.intervals === "" || !question.intervals) {
        errorObj.isValid = false;
        errorObj.msg = "Please specify # of intervals";
        return errorObj;
      } else if (question.intervals < 1 || question.intervals > 13) {
        errorObj.isValid = false;
        errorObj.msg = "Interval must be within 1 and 13";
        return errorObj;
      }

      if (question.minValue == null || question.minValue === "") {
        errorObj.isValid = false;
        errorObj.msg = "Please specify the minimum value";
        return errorObj;
      }

      if (question.maxValue == null || question.maxValue === "") {
        errorObj.isValid = false;
        errorObj.msg = "Please specify the maximum value";
        return errorObj;
      }

      if (Number(question.maxValue) == Number(question.minValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Minimum and maximum values cannot be identical.";
        return errorObj;
      }

      // max values always less than min value
      if (Number(question.minValue) > Number(question.maxValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Max value must be greater than Min value.";
        return errorObj;
      }

      // min max should have value in defined range
      if (Number(question.minValue) < -10000 || Number(question.maxValue) > 10000) {
        errorObj.isValid = false;
        errorObj.msg = "Min and Max values must be within -10,000 and 10,000 range";
        return errorObj;
      }

      // ((max - min) / interval) value should always be a whole.
      // 5.5 % 1 -> 0.5    5 % 1 -> 0
      if (((Number(question.maxValue) - Number(question.minValue)) / question.intervals) % 1 != 0) {
        errorObj.isValid = false;
        errorObj.msg = "The difference between the maximum value and minimum value must be divisible by the intervals value.";
        return errorObj;
      }

      if (this.question.numericRatingScale && (Number(question.minValue) < 0 || Number(question.maxValue) > 13)) {
        errorObj.isValid = false;
        errorObj.msg = "Min and Max values must be within 0 and 13 range";
        return errorObj;
      }

      return { isValid: true };
    }
  }
};
</script>

<style scoped lang="scss">
.option-section {
  &:after {
    content: "";
    clear: both;
    display: block;
  }
  .col-sm-3 {
    float: left;
  }
}

.scaleLabels {
  font-size: 12px;
  color: #666669;
  .labels {
    max-width: 60px;
    width: 100%;
  }
  .ds-label-normal {
    max-width: 100px;
  }
}
.scaleLabels.first {
  max-width: 100%;
  padding-left: 30px;
}
.scaleLabels.last {
  padding-left: 30px;
}
.left-side-align {
  position: relative;
  left: -35px;
}
.right-side-align {
  position: relative;
  right: -35px;
}
.vertical-vue-slider {
  height: 300px !important;
  width: 4px;
  padding: 11px;
  margin-left: 30px;

  &.h-auto {
    height: auto !important;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
  // padding-right: 7px;
}
.add-help-text {
  right: 566.5px;
  padding: 12px 13px;

  &.right-position {
    right: 670px;
  }

  @media (min-width: 1600px) {
    right: 576px;

    &.right-position {
      right: 680px;
    }
  }
}
.textBreak {
  word-break: break-word;
}
.right-label {
  position: relative;
  text-align: right;
  left: 12px;
}
#ds-label .ds-label-normal {
  word-wrap: normal !important;
  max-width: 200px !important;
}
</style>
